export default function useLocaleFlags() {
  const getLocaleFlag = (locale: string) => {
    switch (locale) {
      case "tr":
        return "/flags/tr.svg";
      case "en":
        return "/flags/us.svg";
      default:
        return "";
    }
  };

  return { getLocaleFlag };
}
